export const assetType = {
  noTechnicalForm: "No technical form is available for this asset type",
  infoSection: "Asset type information",
  technicalForm: {
    title: "Technical form",
    warning:
      "Technical forms must be configured using the new <TemplateLink>Technical forms</TemplateLink> section.",
  },
  linkedAssets: "Number of related assets",
  add: {
    label: "Add asset type",
  },
  delete: {
    label: "Delete asset type",
  },
  create: {
    label: "Create asset type",
  },
  information: { label: "Asset type information" },
  form: {
    edit: {
      label: "Edit asset type",
    },
    name: { label: "Name" },
    category: {
      label: "Asset type category",
    },
    technicalForm: {
      label: "Technical form",
      alert:
        'Updating the "Technical form" field, will override any existing technical data of any related assets.',
    },
  },
  deleteTooltipAssets:
    "This asset type cannot be deleted because it's linked to assets.",
};
